import { motion, useScroll, useSpring } from "framer-motion";

/**
 * Thin brass progress bar fixed to the top of the viewport.
 * Reflects how far the user has scrolled through the current page.
 * - z-index sits below AnnouncementBar / Navbar backdrop
 * - 1.5px height, brass #C48F56 with subtle glow
 * - Invisible until the user actually starts scrolling
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 180,
    damping: 28,
    mass: 0.35,
    restDelta: 0.001,
  });

  return (
    <motion.div
      data-testid="scroll-progress"
      style={{ scaleX }}
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[1.5px] bg-[#C48F56] origin-left z-[150] shadow-[0_0_8px_rgba(196,143,86,0.5)]"
    />
  );
}
